import { useTranslation } from 'react-i18next'

import { useRoleLabel } from '@/features/settings/api/useRoleNames'
import { isSeededRole, roleLabel } from '@/lib/navigation'
import type { Role } from '@/types/domain'

/** Renders a role's name: translated for the five shipped roles, and the
 *  founder's own words for one they created (migration 0021).
 *
 *  `name` is for a caller that already holds it (the roles screen). Without
 *  one, a custom role's name is looked up in GET /api/roles (story B3) — the
 *  sidebar, the profile and the users table hold only the key. A seeded role
 *  never asks: the catalogue has its word, and these render on every page. */
export function RoleName({ role, name }: { role: Role; name?: string }) {
  const { t } = useTranslation()
  if (name !== undefined || isSeededRole(role)) {
    const label = roleLabel(role, name)
    return <>{label.translated ? t(label.key) : label.text}</>
  }
  return <ServedRoleName role={role} />
}

/** A custom role, named by what the server serves for it. A component of its
 *  own so the query is mounted only where a lookup is actually needed. */
function ServedRoleName({ role }: { role: Role }) {
  const label = useRoleLabel()
  return <>{label(role)}</>
}
